import React, { useState, useEffect } from 'react';
import { useLayout } from '../../LayoutContext';
import Header from '../../components/header/Header';
import { ContactStyle } from './formsStyle';
import Logo from '../../components/assets/amil-pride.svg';
import Footer from '../../components/footer/Footer';
import imageSource from '../../components/assets/contato.webp';
import videoSource from '../../components/assets/Video_forms.mp4';

const FormContact = () => {
  // Estado inicial para armazenar as preferências do usuário
  const [contactMethod, setContactMethod] = useState('');
  const [preferredTime, setPreferredTime] = useState('');
  const [callDateTime, setCallDateTime] = useState('');

  const { setLayoutConfig } = useLayout(); // Usa o hook para acessar a função de configuração

  useEffect(() => {
    // Configura a cor de fundo e o conteúdo do cabeçalho específicos para HomePage
    setLayoutConfig({
      backgroundColor: '#00022D',
      headerContent: {
        // Defina aqui os dados específicos do cabeçalho para a HomePage
      },
    });
  }, [setLayoutConfig]);

  const handleReturn = (method) => {
    setContactMethod(method);
    sessionStorage.setItem('@contactMethod', JSON.stringify(method));
  };

  const handleTime = (event) => {
    setPreferredTime(event.target.value);
    sessionStorage.setItem(
      '@preferredTime',
      JSON.stringify(event.target.value),
    );
  };

  const handleCall = (event) => {
    setCallDateTime(event.target.value);
    sessionStorage.setItem('@callDateTime', JSON.stringify(event.target.value));
  };

  return (
    <>
      <ContactStyle>
        <section className="formContact__wrapper col-12">
          <div className="container col-12">
            <div className="logo-form">
              <img className="logo" src={Logo} alt="Logo" height={75} />
            </div>
            <div className="title__wrapper">
              <h1 className="title">Como prefere nosso retorno?</h1>
              <div className="buttons__wrapper">
                <button
                  className={`button_link ${
                    contactMethod === 'Whatsapp' ? 'selected' : ''
                  }`}
                  onClick={() => handleReturn('Whatsapp')}
                >
                  Whatsapp
                </button>
                <button
                  className={`button_link ${
                    contactMethod === 'Ligação' ? 'selected' : ''
                  }`}
                  onClick={() => handleReturn('Ligação')}
                >
                  Ligação
                </button>
              </div>
            </div>

            <div className="input__wrapper">
              <label className="inputLabel">
                Você tem preferência de horário?
              </label>
              <input
                className="returnTime"
                type="time"
                onChange={handleTime}
                value={preferredTime}
              />
            </div>

            <div className="input__wrapper">
              <label className="inputLabel">
                Deseja agendar uma vídeo chamada com um de nossos especialistas
                ?
              </label>
              <input
                className="callTime"
                type="datetime-local"
                onChange={handleCall}
                value={callDateTime}
                min={getMinDateTime()}
              />
              <p className="footer-text">
                Caso não queira contato imediato, basta clicar em "continuar".
              </p>
            </div>
          </div>
        </section>
        <Footer />
      </ContactStyle>
    </>
  );
};

// Função auxiliar para calcular a data/hora mínima para o agendamento de chamadas
function getMinDateTime() {
  const today = new Date();
  today.setDate(today.getDate() + 2); // Adiciona 2 dias à data atual
  return today.toISOString().substring(0, 16); // Formata para o valor mínimo aceito pelo input datetime-local
}

export default FormContact;
